import { z } from 'zod';

export type HoldingCreateForm = {
    sap_code: string,
    name: string,
};

export type HoldingCreateFormErrors = {
    sap_code?: string[],
    name?: string[],
};

export const HoldingCreateFormErrorsSchema = z.object({
    sap_code: z.array(z.string()).optional(),
    name: z.array(z.string()).optional(),
});
